<template>
  <div class="container default-title__container"
    :class="class_list">
    <component
      class="default-title pre_wrap"
      :class="{upper_case: uppercase}"
      :is="title_tag">{{ title }}</component>
  </div>
</template>

<script>
export default {
  name: "FullWidthTitle",
  props: {
    /**props**/
    title: {
      type: String,
      default: '',
      admin_type: 'textarea',
    },
    title_tag: {
      type: String,
      default: 'h1',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    text_center: {
      type: Boolean,
      default: true,
      admin_type: 'checkbox',
    },
    visible_mobile: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    uppercase: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    /**props**/
  },
  computed: {
    class_list() {
      return {
        'text-center': this.text_center,
        'visible_mobile': this.visible_mobile
      }
    }
  }
}
</script>
